import { useQuery } from "react-query";

import axios from "axios";

import { USER_COLUMN_RS_ENDPOINT } from "api/data";

export async function fetchGroupOrder(isOrg: boolean, projectId?: string) {
  try {
    const url = `${USER_COLUMN_RS_ENDPOINT}/groupOrder?isOrg=${isOrg ? "true" : "false"}${
      projectId ? "&projectId=" + projectId : ""
    }`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    throw new Error("Unable to fetch group order");
  }
}

interface UseGroupOrderQueryParamsT {
  isOrg: boolean;
  projectId?: string;
  onError?: (error) => void;
  onSuccess?: (data) => void;
  isAutoRefetching?: boolean;
}

interface UseGroupOrderQueryReturnT {
  data;
  error;
  isError: boolean;
  isIdle: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  refetch: () => void;
}

export function useGroupOrderQuery(
  params: UseGroupOrderQueryParamsT
): UseGroupOrderQueryReturnT {
  const { onError, onSuccess, isAutoRefetching = true, isOrg, projectId } = params;

  const queryInfo = useQuery({
    queryKey: ["groupOrder", isOrg],
    queryFn: () => fetchGroupOrder(isOrg, projectId),
    onError: (error) => {
      onError && onError(error);
    },
    onSuccess: (data) => {
      onSuccess && onSuccess(data);
    },
    enabled: isAutoRefetching
  });

  return {
    data: queryInfo.data || [],
    error: queryInfo.error,
    isError: queryInfo.status === "error",
    isIdle: queryInfo.status === "idle",
    isLoading: queryInfo.status === "loading",
    isSuccess: queryInfo.status === "success",
    refetch: queryInfo.refetch
  };
}
